// extracted by mini-css-extract-plugin
module.exports = {"home-container":"home_home-container__1Vczs","hero-container":"home_hero-container__bTxdQ","hero-body":"home_hero-body__3AQ7J"};